/**
 * Values to pass into JCE.Game.promoteVariation method
 */
export const enum PromoteVariationTo {
  /**
   * Promote to the main line (level 0)
   */
  MainLine = 0,
  /**
   * Promote to the direct child of main line (level 1)
   */
  MainLineChild = -1,
  /**
   * Promote to one level above (current level minus 1)
   */
  Parent = 1,
}
